import { FC, useEffect, useState } from "react"
import './index.css'
import InputMask from "react-input-mask";
import api from "../../../services/api";
import useAuth from "../../../hooks/useAuth";
import { usePluginspace } from "../../../hooks/usePluginspace";
import { cpfCnpjNoMask, telephoneNoMask } from "../../../functions/mask";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";
import { Loading } from "../../../components/Loading"



const PerfilInfo: FC = () => {
    const [maskCpfjCnpj, setmaskCpfjCnpj] = useState("999.999.999-99");
    const [maskTelephone, setMaskTelephone] = useState("(99) 9999-9999");
    const [telephone, setTelephone] = useState("");

    const [cpfCustomer, setCpfCustomer] = useState("");
    const [email, setEmail] = useState("")
    const [name, setName] = useState("")
    const [gender, setGender] = useState("")
    const [whatsApp, setWhatsApp] = useState(false)
    const [loading, setLoading] = useState(false);
    const { loginInfo } = useAuth()
    const { getToken } = usePluginspace();
    const navigate = useNavigate();
    const { pluginspace_id } = useParams();

    const atualizar = async () => {
        setLoading(true);
        const update = {
            name: name,
            email: email,
            doc: cpfCnpjNoMask(cpfCustomer),
            cpf: cpfCnpjNoMask(cpfCustomer),
            gender: gender ? gender : 'Não Informar',
            optinWhatsapp: whatsApp,
            phones: [
                {
                    typePhone: "cell",
                    numberPhone: telephoneNoMask(telephone),
                }],
            addresses: []
        }
        await api
            .post(`/api/customer`, update, {
                headers: {
                    Authorization: `Bearer ${await getToken()}`,
                },
            })
            .then((response) => {
                setLoading(false);
                if (response.data.success === true) {

                    navigate(`/${pluginspace_id}/profile`);
                } else {
                    Swal.fire({
                        icon: "error",
                        title: "Erro!",
                        text: "Falha ao cadastrar cliente",
                    });
                }
            })
            .catch((err) => {
                console.log(err)
                setLoading(false);
                console.log(err);
            });
    }

    const getCustomer = async () => {


        setLoading(true);
        if (loginInfo.identifier) {
            try {


                await api
                    .post(
                        `/api/customer/filter`,
                        {
                            cpf: loginInfo.identifier,
                        },
                        {
                            headers: {
                                Authorization: `Bearer ${await getToken()}`,
                            },
                        }
                    )
                    .then(async (response: any) => {
                        setLoading(false);
                        if (response.data.data.length > 0) {
                            const data = response.data.data[0];

                            setCpfCustomer(data.doc)
                            setName(data.name)
                            setEmail(data.email)
                            setGender(data.gender)
                            setWhatsApp(data.optinWhatsapp)
                            setTelephone(data.customerPhones[0].numberPhone)
                        }
                    })
                    .catch((err: any) => {
                        setLoading(false);
                        console.log(err);
                    });
            } catch (error) {
                console.log(error)
                return
            }
        }

        setLoading(false);

    }

    useEffect(() => {
        getCustomer()
    }, [loginInfo.identifier])

    return (
        <>
            {
                loading ? (
                    <div style={{width: '100%', height: 'calc(100vh)'}}>
                        <Loading
                            type="spinningBubbles"
                            color="#FFF"
                            width={64}
                            height={64}
                        />
                    </div>
                ) : (
                    <div className="infoContent">
                        <div className="infoHeader">
                            <h2>Informações pessoais</h2>
                        </div>
                        <div className="infoInputs">
                            <div className="inputs">
                                <div className="headers">
                                    <label>CPF</label>

                                </div>

                                <div className="cpf-Input">
                                    <InputMask
                                        className='myinput'
                                        mask={maskCpfjCnpj}
                                        placeholder="123.456.789-00"
                                        type="text"
                                        value={cpfCustomer}
                                        onChange={(event) => setCpfCustomer(event.target.value)}
                                    />

                                </div>

                            </div>
                            {/* Nome */}
                            <div className="inputs">
                                <div className="headers">
                                    <label>Nome</label>

                                </div>

                                <div className="email-Input">
                                    <input
                                        className="myinput"
                                        type="text"
                                        placeholder={'Nome'}
                                        value={name}
                                        onChange={(event) => setName(event.target.value)}
                                    />

                                </div>
                            </div>

                            {/* Email */}
                            <div className="inputs">
                                <div className="headers">
                                    <label>Email</label>

                                </div>

                                <div className="email-Input">
                                    <input
                                        className="myinput"
                                        type="email"
                                        placeholder={'Email'}
                                        value={email} 
                                        disabled
                                        onChange={(event) => setEmail(event.target.value)}
                                    />

                                </div>
                            </div>

                            {/* Telefone */}
                            <div className="inputs">
                                <div className="headers">
                                    <label>Telefone</label>

                                </div>

                                <div className="email-Input">
                                    <InputMask
                                        className='myinput'
                                        mask={maskTelephone}
                                        placeholder="DDD + Telefone"
                                        type="text"
                                        value={telephone}
                                        onChange={(event) => setTelephone(event.target.value)}
                                    // onFocus={() => setHideMenu(true)}
                                    // onBlur={() => { findCustomer(); }}
                                    />

                                </div>
                            </div>



                            <div className="buttomCadastro">
                                <button
                                    style={{
                                        background: "#6E7586",
                                        color: "white",
                                        border: "none",
                                    }}
                                    onClick={() => atualizar()}
                                >Atualizar</button>
                            </div>
                        </div>
                    </div >

                )

            }
        </>)
}

export { PerfilInfo }